import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const EditResort= (props) => {
  const [user, setUser] = useState(props.currentUser);
  const useStyles = makeStyles((theme) => ({
    updatebtn: {
      color: "#fff",
      backgroundColor: "#0096D6",
      "&:hover": {
        backgroundColor: "#0096D6",
      },
      borderRadius: "20px",
      width: "100px",
      BorderColor: "#fff",
    },
    savebtn: {
      color: "#0096D6",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "#fff",
      },
      borderRadius: "20px",
      width: "100px",
      BorderColor: "#0096D6",
      marginLeft: "10px",
    },
    labelText: {
      fontWeight: "bold",
      marginLeft: "3%",
    },
    datadownloadhead: {
      marginLeft: "0.2%",
      fontWeight: "bold",
      color: "#242021",
      fontSize: "bold",
      display: "none",
      [theme.breakpoints.up("sm")]: {
        display: "block",
      },
    },
    paper1: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit * 3,
      padding: theme.spacing.unit * 10,
      // textAlign: "cr",
      [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 3,
      },
      background: "#F5F6FA ",
      boxShadow: "none",
      // width: "95%",
      // marginLeft: "30px",
      // marginBottom: "190px",
      borderWidth: 1,
      borderRadius: 40,
    },
    clearSearchBtngreen: {
      padding: "0",
      margin: "9px 0 0 0",
      width: "112px",
      textAlign: "right",
      lineHeight: "40px",
      height: "39px",
      color: "#ffffff",
      backgroundColor: "green",
      fontSize: "small",
      textTransform: "none",
      "&:active": {
        backgroundColor: "green",
        color: "#ffffff",
      },
      "&:hover": {
        backgroundColor: "green",
        color: "#ffffff",
      },
    },
    clearSearchBtnred: {
      padding: "0",
      margin: "9px 0 0 0",
      width: "112px",
      textAlign: "right",
      lineHeight: "40px",
      height: "39px",
      color: "#ffffff",
      backgroundColor: "red",
      fontSize: "small",
      textTransform: "none",
      "&:active": {
        backgroundColor: "red",
        color: "#ffffff",
      },
      "&:hover": {
        backgroundColor: "red",
        color: "#ffffff",
      },
    },
    paper: {
      padding: theme.spacing.unit * 6.5,
      // textAlign: "cr",
      [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 3,
      },
      background: "#FFFFFF ",
      boxShadow: "none",
      borderWidth: 1,
      borderRadius: 30,
      // width: "95%",
      // marginLeft: "30px",
      // marginBottom: "190px",
    },
    TextField: {
      width: "100%",
      height: "31px",
      padding: "0",
      paddingBottom: "5px",
      margin: "0 0 10px 0",
      background: "#ffffff 0% 0% ",
      backgroundRepeat: "no-repeat",
      borderColor: "#c4ccdc",
      borderRadius: "28px",
      color: "#98a1b2",
      opacity: "1",
    },
    dialogPaper: {
      minHeight: "20vh",
      maxHeight: "20vh",
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    setUser(props.currentUser);
  }, [props]);
  // You can tell React to skip applying an effect if certain values haven’t changed between re-renders. [ props ]

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    setUser({ ...user, [name]: value });
  };
  const handleChangeActiveFlag = (event) => {
    const { name, checked } = event.target;

    setUser({ ...user, [name]: checked });
  };

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();

        props.updateResort(user);
      }}
    >
      <div
        className={classes.paper}
        style={{ border: "1px ", borderRadius: "9px" }}
      >
        <Grid container direction="row" spacing={3}>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}>SUN Property</label>

            <TextField
              type="text"
              name="sunPropertyID"
              value={user.sunPropertyID}
              onChange={handleInputChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> SUN Room Type</label>

            <TextField
              type="text"
              name="sunRoomType"
              value={user.sunRoomType}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> MARSHA code</label>

            <TextField
              type="text"
              name="marshaCode"
              value={user.marshaCode}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> MARSHA Room pool</label>

            <TextField
              type="text"
              name="marshaRoomPool"
              value={user.marshaRoomPool}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> MARSHA Mini Hotel Code</label>

            <TextField
              type="text"
              name="marshaMiniHotelCode"
              value={user.marshaMiniHotelCode}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> MARSHA Mini Hotel Name</label>

            <TextField
              type="text"
              name="marshaMiniHotelName"
              value={user.marshaMiniHotelName}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> ReservationType</label>

            <TextField
              type="text"
              name="reservationType"
              value={user.reservationType}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> MARSHA Rate Program</label>

            <TextField
              type="text"
              name="marshaRateProgram"
              value={user.marshaRateProgram}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}> Mini Hotel priority </label>

            <TextField
              type="text"
              name="miniHotelPrioirty"
              value={user.miniHotelPrioirty}
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "40px",
                opacity: "1",
                height: "49px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <label className={classes.labelText}>Active only </label>
            <input
              type="checkbox"
              name="activeFlag"
              checked={user.activeFlag}
              onChange={handleChangeActiveFlag}
            />
          </Grid>

          <Grid item md={12} xs={12}>
            <label className={classes.labelText}>Notes</label>

            <TextField
              type="text"
              name="notes"
              value={user.notes}
              multiline
              rowsMax={4}
              id="standard-textarea"
              onChange={handleInputChange} // id="outlined-basic"
              // value={surveyorName}
              // onChange={e => setSurveyorName(e.target.value)}
              // onChange={handleChange}
              //   value={state.password}
              //   onChange={handleChange}
              style={{
                minWidth: "100%",
                background: "#ffffff 0% 0%",
                borderRadius: "50px",
                opacity: "1",
                height: "99px",
                fontSize: "small",
                border: " 1px solid #0096D6",
                backgroundRepeat: "no-repeat",
                padding: "9px 10px 5px",

                margin: "0 0 10px 0",
              }}
              InputProps={{ disableUnderline: true }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item md={12} xs={6}>
            <Button
              variant="contained"
              className={classes.updatebtn}
              type="submit"
              value="submit"
            >
              Update
            </Button>
            <Button
              id="edit_close_btn"
              className={classes.savebtn}
              variant="contained"
              onClick={() => props.setEditing(false)}
            >
              cancel
            </Button>
          </Grid>
        </Grid>
      </div>

      {/* <label>Name</label>
      <input type="text" name="name" value={user.name} onChange={handleInputChange} />
      <label>Username</label>
      <input type="text" name="username" value={user.username} onChange={handleInputChange} />
      <button>Update user</button>
      <button onClick={() => props.setEditing(false)} className="button muted-button">
        Cancel
      </button> */}
    </form>
  );
};

export default EditResort;
